import React from 'react';
import Icon from '../../../components/AppIcon';

const AssignmentStats = ({ stats, targetWorkload }) => {
  const getProgressPercentage = () => {
    if (!stats?.totalPapers) return 0;
    return Math.round((stats?.fullyAssigned / stats?.totalPapers) * 100);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
      <div className="bg-muted/40 rounded-lg p-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-xs text-muted-foreground">Total Papers</span>
          <Icon name="FileText" size={16} className="text-muted-foreground" />
        </div>
        <p className="text-2xl font-bold text-foreground">{stats?.totalPapers || 0}</p>
      </div>

      <div className="bg-success-subtle rounded-lg p-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-xs text-success">Fully Assigned</span>
          <Icon name="CheckCircle2" size={16} className="text-success" />
        </div>
        <p className="text-2xl font-bold text-success">{stats?.fullyAssigned || 0}</p>
      </div>

      <div className="bg-warning-subtle rounded-lg p-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-xs text-warning">Partial</span>
          <Icon name="Clock" size={16} className="text-warning" />
        </div>
        <p className="text-2xl font-bold text-warning">{stats?.partiallyAssigned || 0}</p>
      </div>

      <div className="bg-error-subtle rounded-lg p-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-xs text-error ">Unassigned</span>
          <Icon name="AlertCircle" size={16} className="text-error " />
        </div>
        <p className="text-2xl font-bold text-error ">{stats?.unassigned || 0}</p>
      </div>

      <div className="bg-primary-subtle rounded-lg p-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-xs text-primary">Progress</span>
          <Icon name="TrendingUp" size={16} className="text-primary" />
        </div>
        <p className="text-2xl font-bold text-primary">{getProgressPercentage()}%</p>
      </div>
    </div>
  );
};

export default AssignmentStats;
